module.exports = ".height150{\r\n   height:150px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/general-transaction/import-from-machine/import-from-machine.component.css
// module id = ./src/app/general-transaction/import-from-machine/import-from-machine.component.css
// module chunks = main